import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/groups/:groupId/term-templates/:templateId',
        component: () => import('@/pages/term-templates/TermTemplateShow.vue'),
        props: true,
        children: [
            {
                name: 'term-template-builder',
                path: '',
                component: () => import('@/components/groups/term-templates/ProgramBuilder.vue'),
                props: false,
                meta: {
                    title: 'Term Schedule Builder',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('create a term template'),
                },
            },
            {
                name: 'term-template-preview',
                path: 'preview',
                component: () => import('@/components/groups/term-templates/TermTemplatePreview.vue'),
                props: true,
                meta: {
                    title: 'Term Template Preview',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a term template'),
                },
            },
            {
                name: 'term-template-period-preview',
                path: 'preview/term-period/:termPeriodId',
                component: () => import('@/components/groups/term-templates/TermTemplatePeriodPreview.vue'),
                meta: {
                    title: 'Term Period Preview',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a term template'),
                },
                props: true,
            },
        ],
    },
];
